import { Outlet } from 'react-router-dom';
import { UnauthorizedLayoutHeader } from './UnauthorizedLayoutHeader';
import { UnauthorizedLayoutMobileAppCTA } from './UnauthorizedLayoutMobileAppCTA';
import { usePullToRefresh, useUtmTracking, useWidgetMode } from '@/shared/lib';
import { cn } from '@/shared/utils';
import { useMemo } from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';

const UnauthorizedLayout = () => {
  const { isWidget } = useWidgetMode();
  const { isIsolated } = useUtmTracking();

  const { handleRefresh, isMobile } = usePullToRefresh();

  const styles = useMemo(() => {
    return {
      layout: {
        outerDiv: isWidget
          ? 'flex'
          : isIsolated
            ? 'grid grid-cols-1 md:grid-cols-[minmax(35rem,48rem)]'
            : 'grid grid-cols-1 gap-[4.8rem] md:gap-[3rem] lg:gap-[4.2rem] md:grid-cols-[minmax(35rem,39rem)_auto] lg:grid-cols-[minmax(35rem,48rem)_34.7rem_minmax(25rem,36rem)]',
        innerDiv: isWidget ? 'w-[48rem]' : 'w-full mt-[2rem] md:mt-0',
      },
    };
  }, [isWidget, isIsolated]);

  return (
    <PullToRefresh
      onRefresh={handleRefresh}
      isPullable={isMobile}
      pullingContent={''}
      className="overflow-y-auto bg-background">
      <div className="h-screen flex flex-col">
        <UnauthorizedLayoutHeader />
        <main className="px-[2.4rem] md:px-6 lg:mt-0 flex flex-col md:justify-center flex-1 min-h-0 overflow-y-auto pb-[4rem]">
          <div
            className={cn(
              'w-full h-min justify-center',
              styles.layout.outerDiv
            )}>
            <div className={styles.layout.innerDiv}>
              <Outlet />
            </div>
            {!isWidget && !isIsolated && <UnauthorizedLayoutMobileAppCTA />}
          </div>
        </main>
      </div>
    </PullToRefresh>
  );
};

export { UnauthorizedLayout };
